import type { User, SignInParams, SignUpParams } from "../modules/users/types";
import { apiPost, apiDelete, apiGet } from "./utils";

export const usersApi = {
  signIn: async (params: SignInParams): Promise<User> => {
    return apiPost<User>("/api/v1/users/log_in", params);
  },

  signUp: async (params: SignUpParams): Promise<User> => {
    return apiPost<User>("/api/v1/users", {
      email: params.email,
      password: params.password,
      passwordConfirmation: params.passwordConfirmation,
      workspaceAttributes: {
        name: params.workspaceName,
        slug: params.workspaceSlug,
      },
    });
  },

  signOut: async (): Promise<void> => {
    return apiDelete("/api/v1/users/log_out");
  },

  getCurrentUser: async (): Promise<User> => {
    return apiGet<User>("/api/v1/users/me");
  },
};
